module.exports = __webpack_public_path__ + "static/media/BefiWallet.59ed683b.png";